import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  root: {
    position: 'relative',
    marginBottom: 32,
    [breakpoints.up('sm')]: {
      marginBottom: 64,
    },
    [breakpoints.up('lg')]: {
      marginBottom: 80,
    },
  },
  cardsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1.5rem 1rem',
    margin: 0,
    listStyleType: 'none',
    [breakpoints.up('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      flexDirection: 'unset',
      padding: '2.5rem 2rem',
    },
    [breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
      padding: 32,
    },
  },
  veeva: {
    position: 'absolute',
    left: '0.25rem',
    top: '0.25rem',
    color: palette.grey[200],
    fontSize: '0.25rem',
    lineHeight: 1.1,
  },
}));
